// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as PartnerScoreHelper from "../../../domain/helper/PartnerScoreHelper.bs.js";
import * as PartnerScoreAssetHelper from "../../../domain/helper/PartnerScoreAssetHelper.bs.js";

function CancellationScoreRowCmp(Props) {
  var thresholds = Props.thresholds;
  var table_details = Props.table_details;
  var max_score = Props.max_score;
  return React.createElement("tr", {
              className: "cancellation-rate-row"
            }, React.createElement("td", {
                  className: "cancellation-rate-header"
                }, table_details.cancellation_score_text), $$Array.of_list(Belt_List.mapWithIndex(thresholds, (function (index, threshold) {
                        return React.createElement("td", {
                                    className: "threshold"
                                  }, PartnerScoreAssetHelper.getThresholdIcon(index, Belt_List.length(thresholds)), React.createElement("div", {
                                        className: "threshold-content",
                                        style: {
                                          fontWeight: "600"
                                        }
                                      }, PartnerScoreHelper.getSliderMarkingValue(threshold, max_score)));
                      }))));
}

var make = CancellationScoreRowCmp;

export {
  make ,
  
}
/* react Not a pure module */
